const zh_CN = {
    local: 'zh_CN',
    app_name: '国象联盟',
    app_title: '国象联盟 - 专业国际象棋平台',
    app_describe: '国内专业国际象棋平台，国象爱好者与职业棋手们的集合地。\n200万+注册用户，100万+战术训练题，1000万+国际大师名局棋谱，精彩不断的官方赛事，AI数据分析，开局+残局百科，局面搜索引擎，助你快速提高棋力！',
    txt_scan_download: '扫 描 下 载',
    txt_app_screenshots: '应用截图',
    app_icp_copyright: '京ICP备15045948号 Copyright © 2015-' + new Date().getFullYear() + ' 北京棋易科技有限公司',
    app_icp: '京ICP备15045948号',
    app_gov: '京公网安备11011302007631号',
    app_copyright: 'Copyright © 2015-' + new Date().getFullYear() + ' 北京棋易科技有限公司',
    txt_open_in_browser: '点击菜单，在浏览器中打开',
    txt_error: '发生了一个未知的错误',
    btn_error: '返 回 主 页',
    app_invite: '国内专业国际象棋平台，国象爱好者与职业棋手们的集合地！\n下载并登入国象联盟成为新用户，进入主界面左拉抽屉菜单点击邀请好友，填写邀请码获得10金币奖励。发送邀请码给好友，每个输入你邀请码的好友，可使你获得5金币，共可累计获得25金币奖励！',
    txt_invite: '邀请码 - ',
    btn_board_turn: '旋转棋盘',
    btn_pgn_view: '查看棋谱',
    btn_pgn_download: '下载棋谱',
    btn_app_download: '下载应用',
    btn_download: '下载',
    btn_close: '关闭',
    puzzle_white_first: '白先',
    puzzle_black_first: '黑先',
    puzzle_solve_success: '解题成功',
    puzzle_solve_warn: '存在更优走法',
    puzzle_solve_error: '解题失败',
    pc_mumu: 'PC（MUMU模拟器专版）',
};
export default zh_CN;



// WEBPACK FOOTER //
// ./src/zh_CN.js